<ion-header style="width: var(--curafida-wrapper-mobile-width); display: contents">
    <div class="wrapper-patient-home">
        <div class="flex-container-row justify-content-space-between full-width vertical-center">
            <div
                class="flex-container-row vertical-center"
                style="flex-grow: 1">
                <ion-buttons>
                    <ion-menu-toggle>
                        <ion-button
                            class="toolbar-patient-button-start"
                            fill="clear"
                            color="primary">
                            <ion-icon
                                style="border-radius: 50%; border: 3px solid var(--ion-color-primary)"
                                class="menu-icon-without-horizontal-margin"
                                name="menu-sharp"></ion-icon>
                        </ion-button>
                    </ion-menu-toggle>
                    @if (
                        router.url === `/member/patient/home?home=${tab()}` ||
                        (router.url.includes(`/member/patient/home`) &&
                            !router.url.includes('program') &&
                            !router.url.includes('article')) ||
                        router.url.includes('register') ||
                        router.url.includes('shop/main')
                    ) {
                        <ion-button
                            fill="clear"
                            disabled>
                            <ion-icon
                                class="toolbar-patient-icon"
                                [src]="'assets/app-icons/empty.svg'"></ion-icon>
                        </ion-button>
                    } @else {
                        <ion-button
                            fill="clear"
                            (click)="backToHome()"
                            color="primary">
                            <ion-icon
                                class="toolbar-patient-icon"
                                name="arrow-back-outline"></ion-icon>
                        </ion-button>
                    }
                </ion-buttons>
            </div>
            <div
                class="flex-container-row justify-content-center"
                style="flex-grow: 1">
                @if (configService.logoUrl()) {
                    <div>
                        <ion-button
                            class="toolbar-patient-button-logo"
                            fill="clear"
                            (click)="backToHome()">
                            <img
                                alt="logo"
                                style="max-height: 60px; max-width: 140px"
                                src="{{ configService.logoUrl() }}" />
                        </ion-button>
                    </div>
                }
            </div>
            <div
                class="flex-container-row justify-content-flex-end"
                style="flex-grow: 1">
                <ion-buttons>
                    @for (button of toolbarService.patientActionButtons(); track button.iconName) {
                        @if (
                            !configService.config()?.configuration?.features?.profile?.enabled &&
                            authService.isAuthenticated()
                        ) {
                            <ion-button
                                fill="clear"
                                disabled>
                                <ion-icon
                                    class="toolbar-patient-icon"
                                    [src]="'assets/app-icons/empty.svg'"></ion-icon>
                            </ion-button>
                        }
                        <ion-button
                            fill="clear"
                            (click)="button.onClick()"
                            color="primary">
                            <ion-icon
                                class="toolbar-patient-icon"
                                [name]="button.iconName"></ion-icon>
                        </ion-button>
                    } @empty {
                        <ion-button
                            fill="clear"
                            disabled>
                            <ion-icon
                                class="toolbar-patient-icon"
                                [src]="'assets/app-icons/empty.svg'"></ion-icon>
                        </ion-button>
                        @if (
                            !configService.config()?.configuration?.features?.profile?.enabled &&
                            authService.isAuthenticated()
                        ) {
                            <ion-button
                                fill="clear"
                                disabled>
                                <ion-icon
                                    class="toolbar-patient-icon"
                                    [src]="'assets/app-icons/empty.svg'"></ion-icon>
                            </ion-button>
                        }
                    }
                    @if (
                        authService.isAuthenticated() &&
                        configService.config()?.configuration?.features?.profile?.enabled
                    ) {
                        <ion-button
                            (click)="openProfile()"
                            class="toolbar-patient-button-end"
                            fill="clear"
                            color="primary">
                            <ion-icon
                                class="profil-icon"
                                name="person-circle"></ion-icon>
                        </ion-button>
                    } @else {
                        <ion-button
                            class="toolbar-patient-button-end"
                            fill="clear"
                            disabled>
                            <ion-icon
                                class="profil-icon"
                                [src]="'assets/app-icons/empty.svg'"></ion-icon>
                        </ion-button>
                    }
                </ion-buttons>
            </div>
        </div>
    </div>
</ion-header>
